module.exports = __webpack_public_path__ + "img/homepage.41007ba9.svg";